var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tm-bill list-item",on:{"click":_vm.onClick}},[_c('span',{staticClass:"name",domProps:{"textContent":_vm._s(_vm.name)}}),_c('span',{staticClass:"total",domProps:{"innerHTML":_vm._s(_vm.total)}})])}
var staticRenderFns = []

export { render, staticRenderFns }